import FormFieldDropdown from '@sendsprint/ui-react/dist/components/Form/formDropdown';
import React from 'react';
import { intervalsData } from '../../../data/intervals';

const IntervalDropdown = () => {
  return (
    <FormFieldDropdown
      data={intervalsData}
      emptyOptionLabel=""
      name="interval"
      showFilter={false}
      label="Select payment interval"
      optionLabel="interval"
      extraInfo="To allow customers select the interval, leave this field"
      optionValue="id"
    />
  );
};

export default IntervalDropdown;
